
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StatusItemProps } from ".";
import { loading, create } from "store/role";
import { AppMessage } from "components";

interface ApiStatusCreateInputProps extends Omit<StatusItemProps, "id"> {
}

type ApiStatusCreateOutputProps = OutputBaseProps<{ item: StatusItemProps; }, ApiStatusCreateInputProps>

export const apiStatusCreate = async (data: ApiStatusCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiStatusCreateOutputProps>("/api/status/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};